import argentina from "../assets/country/argentina.png"
import brasil from "../assets/country/brasil.png"
import colombia from "../assets/country/copu.png"
import el_salvador from "../assets/country/el_salvador.png"
import EAU from "../assets/country/EAU.png"
import espana from "../assets/country/espana.png"
import estados_unidos from "../assets/country/estados_unidos.png"
import mexico from "../assets/country/mexico.png"
import panama from "../assets/country/panama.png"
import peru from "../assets/country/peru.png"
import venezuela from "../assets/country/venezuela.png"



export const codePhones = {

    es: [
        {
            "label": "Argentina (+54)",
            "code": "+54",
            "flag": argentina
        },
        {
            "label": "Brasil (+55)",
            "code": "+55",
            "flag": brasil
        },
        {
            "label": "Colombia (+57)",
            "code": "+57",
            "flag": colombia
        },
        {
            "label": "El Salvador (+503)",
            "code": "+503",
            "flag": el_salvador
        },
        {
            "label": "Emiratos Árabes Unidos (+971)",
            "code": "+971",
            "flag": EAU
        },
        {
            "label": "España (+34)",
            "code": "+34",
            "flag": espana
        },
        {
            "label": "Estados Unidos (+1)",
            "code": "+1",
            "flag": estados_unidos
        },
        {
            "label": "México (+52)",
            "code": "+52",
            "flag": mexico
        },
        {
            "label": "Panamá (+507)",
            "code": "+507",
            "flag": panama
        },
        {
            "label": "Perú (+51)",
            "code": "+51",
            "flag": peru
        },
        {
            "label": "Venezuela (+58)",
            "code": "+58",
            "flag": venezuela
        }
    ],

    "en": [
        {
            "label": "Argentina (+54)",
            "code": "+54",
            "flag": argentina
        },
        {
            "label": "Brazil (+55)",
            "code": "+55",
            "flag": brasil
        },
        {
            "label": "Colombia (+57)",
            "code": "+57",
            "flag": colombia
        },
        {
            "label": "El Salvador (+503)",
            "code": "+503",
            "flag": el_salvador
        },
        {
            "label": "United Arab Emirates (+971)",
            "code": "+971",
            "flag": EAU
        },
        {
            "label": "Spain (+34)",
            "code": "+34",
            "flag": espana
        },
        {
            "label": "United States (+1)",
            "code": "+1",
            "flag": estados_unidos
        },
        {
            "label": "Mexico (+52)",
            "code": "+52",
            "flag": mexico
        },
        {
            "label": "Panama (+507)",
            "code": "+507",
            "flag": panama
        },
        {
            "label": "Peru (+51)",
            "code": "+51",
            "flag": peru
        },
        {
            "label": "Venezuela (+58)",
            "code": "+58",
            "flag": venezuela
        }
    ]






}